import React from 'react'

import { Divider, Col, Row } from '_zari/core'

import * as FormGroups from './formGroups'
import * as Sections from './sections'

const ComprobantesElectronicosTab = () => {
  const filtrosFormikRef = React.useRef(null)

  const [documentos, setDocumentos] = React.useState([])
  const [seleccionarTodos, setSeleccionarTodos] = React.useState(false)
  const [enviarCorreoAutomatico, setEnviarCorreoAutomatico] = React.useState(false)

  const repetirConsultaDocumentos = React.useCallback(() => {
    if (filtrosFormikRef.current && filtrosFormikRef.current.handleSubmit) {
      filtrosFormikRef.current.handleSubmit()
    }
  }, [])

  const actualizarListaDocumentos = React.useCallback(nuevaLista => {
    setDocumentos(nuevaLista)
  }, [])

  const clickSeleccionarTodos = React.useCallback(() => {
    setSeleccionarTodos(prevChecked => {
      setDocumentos(prev => {
        return prev.map(x => ({
          ...x,
          checked: !prevChecked
        }))
      })
      return !prevChecked
    })
  }, [])

  const clickDocumentoCheck = React.useCallback(({ _id }) => {
    setDocumentos(prev => {
      return prev.map(x => ({
        ...x,
        checked: x._id === _id ? !x.checked : x.checked
      }))
    })
  }, [])

  return (
    <>
      <Sections.FiltrosSection innerRef={filtrosFormikRef} actualizarListaDocumentos={actualizarListaDocumentos} />
      <Divider noMargin />
      <Row>
        <Col md={12} className='px-4'>
          <FormGroups.SeleccionarTodoFormGroup value={seleccionarTodos} onChange={clickSeleccionarTodos} />
          <FormGroups.FlagEnviarCorreoAutomaticoFormGroup value={enviarCorreoAutomatico} onChange={() => setEnviarCorreoAutomatico(prev => !prev)} />
        </Col>
      </Row>
      <Sections.ListaDocumentosSection
        documentos={documentos}
        clickDocumentoCheck={clickDocumentoCheck}
        repetirConsultaDocumentos={repetirConsultaDocumentos}
      />
      <Sections.BotonesEnvioSection
        documentos={documentos}
        enviarCorreoAutomatico={enviarCorreoAutomatico}
        repetirConsultaDocumentos={repetirConsultaDocumentos}
      />
    </>
  )
}

export default React.memo(ComprobantesElectronicosTab)
